export default String.raw`
<dialog class="dialog check-deligoo check-deligoo-popup-js middle">
	<div class="dialog__header">
		<h2 class="dialog__header-title">{{translations.DeligooTitle}}</h2>
		<form method="dialog">
			<button class="dialog__close close-js" aria-label="{{ translations.Close }}">
				<svg aria-hidden="true" height="24" width="24">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
				</svg>
			</button>
		</form>
	</div>
	<div class="dialog__content">
		<p class="check-deligoo__text">{{translations.DeligooText}}</p>
		<div class="check-deligoo__form">
			<div class="form__input-wrapper">
				<label for="zipCode" class="form__input-info input-info-js">
					<span class="required">* </span>{{ translations.ZipCode }}
				</label>
				<input class="form__input-value input-value-js" id="zipCode" type="text" name="zipCode" value="{{customer.Address.ZipCode}}" maxlength="20" required>
				<div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillZipCode }}</div>
				<div class="form__invalid-input validation-zip-code-js hidden-js">{{ translations.FillProperZipCode }} <span class="zip-format-js"></span></div>
			</div>
			<button class="primary-action-button check-deligoo-js">
				<span>{{translations.Check}}</span>
			</button>
		</div>
		<div class="check-deligoo__result check-deligoo-success-js hidden-js">
			<svg height="32" width="32" fill="#008945">
				<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
			</svg>
			<p>{{translations.DeligooSuccess}}</p>
		</div>
		<div class="check-deligoo__result check-deligoo-failure-js hidden-js">
			<svg height="32" width="32" fill="#DA2442">
				<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-circle-{{settings.iconStyle}}"></use>
			</svg>
			<p>{{translations.DeligooError}}</p>
		</div>
	</div>
</dialog>
`